import Card from '@zenbusiness/zui/Card';
import CardHeader from '@zenbusiness/zui/CardHeader';
import SharedAsset from '@zenbusiness/zui/SharedAsset';
import Stack from '@zenbusiness/zui/Stack';
import { superstyled } from '@zenbusiness/zui/styles';
import Text from '@zenbusiness/zui/Text';

export const Root = superstyled({
  tag: Card,
  name: 'HighlightSection',
  slot: 'Root',
  styles: ({ theme }) => ({
    display: 'flex',
    flexDirection: 'column-reverse',
    backgroundColor: theme.palette.fixed.grey[950],
    gap: theme.spacing(3),
    padding: theme.spacing(3),
    borderRadius: theme.shape.rounded.xl,

    [theme.breakpoints.up('lg')]: {
      gap: theme.spacing(5),
      flexDirection: 'row',
      alignItems: 'center',
    },
  }),
});

export const ContentContainer = superstyled({
  tag: Stack,
  name: 'HighlightSection',
  slot: 'ContentContainer',
  styles: ({ theme, border }) => ({
    flex: 1,
    gap: theme.spacing(3),
    overflow: 'hidden',
    borderRadius: border && theme.shape.rounded.xl,
  }),
});

export const Image = superstyled({
  name: 'ZuiHeaderImage',
  slot: 'Root',
  tag: SharedAsset,
  styles: ({ theme }) => ({
    width: '100%',
    minHeight: '8.875rem',
    borderRadius: theme.shape.rounded.xl,
    objectPosition: 'top',
    objectFit: 'cover',

    [theme.breakpoints.up('lg')]: {
      minHeight: '15rem',
      maxHeight: '19rem',
    },
  }),
});

export const Header = superstyled({
  tag: CardHeader,
  name: 'HighlightSection',
  slot: 'Header',
  styles: ({ theme }) => ({
    gap: theme.spacing(1),

    [theme.breakpoints.up('lg')]: {
      gap: theme.spacing(2),
    },
  }),
});

export const CardTitle = superstyled({
  tag: Text,
  name: 'HighlightSection',
  slot: 'CardTitle',
  styles: () => ({
    textWrap: 'wrap',
  }),
});

export const CardSubTitle = superstyled({
  tag: Text,
  name: 'HighlightSection',
  slot: 'CardSubTitle',
  styles: ({ theme }) => ({
    fontSize: '0.75rem',
    whiteSpace: 'pre-line',

    [theme.breakpoints.up('lg')]: {
      fontSize: '0.875rem',
    },
  }),
});

export const IconContainer = superstyled({
  tag: Stack,
  name: 'HighlightSection',
  slot: 'IconContainer',
  styles: ({ theme }) => ({
    justifyContent: 'center',
    alignItems: 'center',
    width: '1.75rem',
    height: '1.75rem',
    backgroundColor: theme.palette.background.green.main,
    borderRadius: theme.shape.rounded.full,

    [theme.breakpoints.up('lg')]: {
      width: '2.25rem',
      height: '2.25rem',
    },
  }),
});

export const Icon = superstyled({
  tag: SharedAsset,
  name: 'HighlightSection',
  slot: 'Icon',
  styles: ({ theme }) => ({
    width: '1rem',
    height: '1rem',

    [theme.breakpoints.up('lg')]: {
      width: '1.25rem',
      height: '1.25rem',
    },
  }),
});

export const BulletList = superstyled({
  tag: 'ul',
  name: 'HighlightSection',
  slot: 'BulletList',
  styles: ({ theme }) => ({
    paddingLeft: 36,
    listStyleType: 'disc',
    color: 'white',
    fontSize: '0.75rem',
    marginTop: theme.spacing(-2),

    [theme.breakpoints.up('lg')]: {
      fontSize: '0.875rem',
    },
  }),
});

export const BulletItem = superstyled({
  tag: 'li',
  name: 'HighlightSection',
  slot: 'BulletItem',
  styles: () => ({
    margin: 0,
  }),
});
